/**
 * Generate consistent canonical URLs to prevent duplicate content issues
 */
export const getCanonicalUrl = (path) => {
  const baseUrl = 'https://maimotion.com';
  
  // Remove trailing slash except for root
  const cleanPath = path === '/' ? '' : path.replace(/\/$/, '');
  
  return `${baseUrl}${cleanPath}`;
};

/**
 * Get current page canonical URL from window location
 */
export const getCurrentCanonicalUrl = () => {
  if (typeof window === 'undefined') return '';
  
  const path = window.location.pathname;
  return getCanonicalUrl(path);
};